import { ContentCopy, Delete, Edit } from '@mui/icons-material'
import { Button } from '@mui/material'

import React from 'react'

// Duplicate / Edit / Delete action row shared by the admin preview modes of
// the marketplace and canteen item modals. Layout is owned by the caller.
// Duplicate and Delete render only when handled: the vendor portal reuses this
// preview without the admin-only delete mutation.
const PreviewActionBar: React.FC<{
  onDuplicate?: () => void
  onEdit: () => void
  onDelete?: () => void
}> = ({ onDuplicate, onEdit, onDelete }) => (
  <>
    {onDuplicate && (
      <Button
        variant="outlined"
        color="secondary"
        startIcon={<ContentCopy />}
        onClick={onDuplicate}>
        Duplicate
      </Button>
    )}
    <Button variant="contained" startIcon={<Edit />} onClick={onEdit}>
      Edit
    </Button>
    {onDelete && (
      <Button variant="outlined" color="error" startIcon={<Delete />} onClick={onDelete}>
        Delete
      </Button>
    )}
  </>
)

export default PreviewActionBar
